import React from 'react';
import classNames from 'classnames';
import * as styles from '../Card/Card.module.scss';

type BaseProps = {
  className?: string;
};

type CardProps = object & BaseProps & React.HTMLProps<HTMLDivElement>;

export const Card = ({ children, className, ...rest }: CardProps) => {
  return (
    <div className={classNames(styles.Card, className)} {...rest}>
      {children}
    </div>
  );
};
